import { useQuery } from '@tanstack/react-query';
import { createApiClient } from '../client';
import { useAuth } from '../../auth/useAuth';

export interface NotificationDto {
  id: string;
  title: string;
  message: string;
  kind: string;
  isRead: boolean;
  relatedEntityId?: string | null;
  createdAt: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export function useNotifications(unreadOnly = false) {
  const { getToken } = useAuth();
  return useQuery<NotificationDto[]>({
    queryKey: ['notifications', { unreadOnly }],
    queryFn: async () => {
      const client = createApiClient(getToken);
      const query = unreadOnly ? '?unread=true' : '';
      const response = await client
        .get(`api/v2/notifications${query}`)
        .json<ApiResponse<NotificationDto[]>>();
      return response.data ?? [];
    },
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
